import { useId } from 'react';
import type { Doctrine, Faction } from '@tb/shared';

/** Vector projection markers stay sharp at every display density; no animation loop or asset download. */
export function HolographicCity({ faction }: { faction: Faction }) {
  const id = useId().replace(/:/g, '');
  const blue = faction === 'WEST';
  return <svg className={`city-hologram ${blue ? 'frontiers' : 'heritage'}`} viewBox="0 0 120 110" aria-hidden="true" data-testid="city-hologram" data-faction={faction}>
    <defs>
      <linearGradient id={`${id}-body`} x1="0" y1="0" x2="0" y2="1"><stop stopColor="currentColor" stopOpacity=".3" /><stop offset="1" stopColor="currentColor" stopOpacity=".06" /></linearGradient>
      <linearGradient id={`${id}-beam`} x1="0" y1="0" x2="0" y2="1"><stop stopColor="currentColor" stopOpacity="0" /><stop offset="1" stopColor="currentColor" stopOpacity=".13" /></linearGradient>
      <pattern id={`${id}-scan`} width="4" height="4" patternUnits="userSpaceOnUse"><path d="M0 0H4" stroke="currentColor" strokeOpacity=".16" strokeWidth=".7" /></pattern>
    </defs>
    <path d="M20 14 12 91Q60 112 108 91L100 14Z" fill={`url(#${id}-beam)`} />
    <g className="hologram-base" fill="none" stroke="currentColor"><ellipse cx="60" cy="91" rx="48" ry="12" strokeOpacity=".35" /><ellipse cx="60" cy="91" rx="40" ry="9" strokeWidth="1.4" /><path d="M12 91h8m80 0h8M60 79v5m0 14v5" strokeOpacity=".7" /></g>
    <g stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" fill={`url(#${id}-body)`}>
      {blue ? <>
        <path d="M46 91V23l12-6 16 6v68Z" /><path d="m58 17 0 74m-12-68 12 5 16-5" fill="none" />
        <path d="M23 91V51l10-5 13 5v40Zm51 0V42l9-4 14 5v48Z" /><path d="M34 46v45m-11-40 11 4 12-4m37-13v53m-9-49 9 5 14-4" fill="none" />
        <path d="M38 92V72l10-4 13 4v21Zm23 0V63l11-4 13 4v30Z" />
        <path d="M63 8v8m-4-5h8M28 60v4m0 4v4m0 4v4m11-21v5m0 4v4m12-38v5m0 4v5m0 4v5m0 4v5m13-32v5m0 4v5m0 4v5m0 4v5m0 4v5m24-20v5m0 4v5m0 4v5m-44 7v6m26-15v6m9-6v6" fill="none" strokeOpacity=".8" />
      </> : <>
        <path d="M33 90V47h10v-7h9v7h16v-7h9v7h10v43Z" /><path d="M25 88V44h14v44Zm56 0V44h14v44Z" />
        <path d="m23 44 9-23 9 23Zm56 0 9-23 9 23Z" /><path d="M50 86V28h20v58ZM47 28 60 7 73 28Z" />
        <path d="M43 91V66h7v-6h8v6h6v-6h8v6h7v25Z" />
        <path d="M54 91V80q6-11 12 0v11M29 51v7m6-7v7m50-7v7m6-7v7M56 36v7m8-7v7M32 17v5m56-5v5M60 3v5" fill="none" />
      </>}
    </g>
    <path d={blue ? 'M23 51h23V23l12-6 16 6v19l9-4 14 5v48H23Z' : 'M25 44h14v3h11V28h20v19h11v-3h14v47H25Z'} fill={`url(#${id}-scan)`} />
  </svg>;
}

export function DoctrineIndicator({ doctrine }: { doctrine: Doctrine }) {
  return <svg className="doctrine-indicator" viewBox="0 0 20 20" aria-hidden="true" data-doctrine={doctrine} fill="none" stroke="currentColor" strokeWidth="1.6">
    {doctrine === 'OFFENSIVE' ? <><path d="m10 2 8 15H2Z" /><path d="M10 7v4m0 2v1" /></> : doctrine === 'DEFENSIVE' ? <><path d="m10 2 7 3v5q0 5-7 8-7-3-7-8V5Z" /><path d="M10 6v7m-3-4h6" /></> : <circle cx="10" cy="10" r="7" />}
  </svg>;
}
